<template>
  <div class="zero-knowedge">
    <common-bg-plate>
      <change-chain></change-chain>
      <div v-show="hasContract" class="list-box">
        <action-bar>
          <btn-style :btn-list="btnList"></btn-style>
        </action-bar>
        <div v-for="(item, i) in list" :key="i" class="list-item">
          <div class="list-info">
            <div v-for="(ele, index) in showArr" :key="ele + index" class="item-line">
              <div class="item-label">{{ ele.label }}：</div>
              <div class="item-text">
                {{
                  ele.value == 'createdTime' ? formatTime(item[ele.value] * 1000) : item[ele.value]
                }}
              </div>
            </div>
          </div>
          <div class="list-operate">
            <el-button type="primary" class="detail-btn" @click="goDetail(item)"
              >查看详情</el-button
            >
          </div>
        </div>
      </div>
      <div v-show="!hasContract" class="list-box">
        <no-contract @update:list="getContractStatus"></no-contract>
      </div>
    </common-bg-plate>
    <create-task ref="createTaskRef" @update:list="getList()"></create-task>
  </div>
</template>
<script>
import changeChain from './components/changeChain.vue'
import createTask from './components/createTask.vue'
import noContract from './components/zeroNoContract.vue'
export default {
  components: {
    changeChain,
    createTask,
    noContract
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '新建隐私计算任务',
          click: () => {
            return this.createTask()
          }
        }
      ],
      paging: {
        pageNo: 1,
        pageSize: 10,
        total: 10
      },
      list: [],
      showArr: [
        { label: '数据名称', value: 'name' },
        { label: '创建时间', value: 'createdTime' },
        { label: '数据描述', value: 'description' }
      ],
      chainId: '',
      hasContract: false
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.chainId = val
        this.getContractStatus()
      }
    }
  },
  mounted() {
    this.chainId = this.$store.state.computing.chainId
    if (this.chainId) {
      this.getContractStatus()
    }
  },
  methods: {
    getContractStatus() {
      let params = {
        chainId: this.chainId
      }
      this.$apis.privacy.getZeroHasContract(params).then(res => {
        if (res.errors && res.errors[0].code == 40011) {
          this.hasContract = false
        } else {
          this.hasContract = true
          this.getList()
        }
      })
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    },
    getList() {
      this.$apis.privacy.getZeroList({ chainId: this.chainId }).then(res => {
        this.list = res.data
      })
    },
    createTask() {
      this.$refs.createTaskRef.handleOpen('zero')
    },
    goDetail(row) {
      this.$router.push({
        name: 'knowedgeTaskDetail',
        query: {
          taskId: row.taskId,
          chainId: this.chainId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'zero-knowedge',
  (
    --zero-knowedge-body-item-border-color: #33496e,
    --zero-knowedge-body-item-label-color: rgba(255, 255, 255, 0.6),
    --zero-knowedge-body-item-text-color: #fff
  ),
  (
    --zero-knowedge-body-item-border-color: #ebebeb,
    --zero-knowedge-body-item-label-color: rgba(90, 105, 115, 1),
    --zero-knowedge-body-item-text-color: rgba(25, 34, 39, 1)
  )
);
.zero-knowedge {
  @include adaptation(
    (
      --zero-knowedge-top-bar-border-width: 1px,
      --zero-knowedge-body-padding: 24px 20px,
      --zero-knowedge-body-item-padding: 20px 20px 8px 16px,
      --zero-knowedge-body-item-margin-bottom: 12px,
      --zero-knowedge-body-item-operate-width: 175px,
      --zero-knowedge-body-item-font-size: 14px,
      --zero-knowedge-body-item-label-width: 70px,
      --zero-knowedge-body-item-operate-padding: 5px
    )
  );
  --zero-knowedge-min-height: var(--base-main-router-body-avaliable-height);
  color: var(--zero-knowedge-color);
  .common-bg-plate {
    min-height: var(--zero-knowedge-min-height);
    .list-box {
      padding: var(--zero-knowedge-body-padding);
      .list-item {
        padding: var(--zero-knowedge-body-item-padding);
        border: var(--zero-knowedge-top-bar-border-width) solid
          var(--zero-knowedge-body-item-border-color);
        margin-bottom: var(--zero-knowedge-body-item-margin-bottom);
        display: flex;
        .list-info {
          width: calc(100% - var(--zero-knowedge-body-item-operate-width));
          .item-line {
            display: flex;
            align-items: center;
            font-size: var(--zero-knowedge-body-item-font-size);
            margin-bottom: var(--zero-knowedge-body-item-margin-bottom);
            .item-label {
              width: var(--zero-knowedge-body-item-label-width);
              flex-shrink: 0;
              color: var(--zero-knowedge-body-item-label-color);
            }
            .item-text {
              flex: 1;
              color: var(--zero-knowedge-body-item-text-color);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              padding-right: 1%;
            }
          }
        }
        .list-operate {
          flex-shrink: 0;
          width: var(--zero-knowedge-body-item-operate-width);
          padding-top: var(--zero-knowedge-body-item-operate-padding);
          text-align: right;
          .close-btn {
            margin-left: 0;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            border-left: 0;
          }
        }
      }
    }
  }
}
</style>
